export const home = 2153242
export const residencial = 2153242
export const residencial_palermo = 3761458
export const residencial_recoleta = 3761458
export const residencial_sanisidro = 3761467
export const residencial_nordelta = 3761474
export const residencial_puertos = 3761481
export const residencial_pilar = 3761487
export const residencial_escobar = 3761488
export const oficina = 3761392
export const locales = 3761353
export const industrias = 3761409
export const hoteles = 3761398
export const campos = 3761405
export const emprendimientos = 3761414
export const terrenos = 2153242
export const tasaciones = 3761422



// WEBPACK FOOTER //
// ./src/constants/propertyCodesForForms.js